import Vue from 'vue'
import moment from 'expose-loader?Moment!moment'
import axios from 'axios'

var event;

export const locationsCalendarVueApp = new Vue({
	el: '#location-calendar-app',
	data: {
		events: [],
		eventDrawerVisible: false,
		selectedEvent: {},
		backgroundColor: '',
		loading: true
	},
	delimiters: ['${', '}'],
	created: function() {

		let slug = '';
		let pathArray = window.location.pathname.split("/")
		if (pathArray) {
			slug = pathArray[pathArray.length - 1]
		}

		axios.get('/locations/location-detail.json?slug='+slug)
		.then(response => {
			this.events = response.data.events;
			this.loading = false;
		});

	},

	watch: {
		eventDrawerVisible(val) {
			let body = $('body');
			if(val) {
				body.addClass('drawer-open');
			} else {
				body.removeClass('drawer-open');
			}
		}
	},

	methods: {

		getBackgroundColor: function() {
			var element = document.getElementById(this.selectedEvent.id),
			style = window.getComputedStyle(element),
			color = style.getPropertyValue('border-bottom-color');
			this.backgroundColor = color;
		},

		showEvent: function(event, e) {
			e.preventDefault();

			document.onkeydown = (e) => {
				if (this.eventDrawerVisible) {
					switch (e.keyCode) {
						case 27:
								this.hideEvent();
								break;
						case 37:
								this.prevEvent();
								break;
						case 39:
								this.nextEvent();
								break;
					}
				}
			};

			this.selectedEvent = event;
			this.getBackgroundColor();
			this.eventDrawerVisible = true;
		},

		hideEvent: function() {
			this.eventDrawerVisible = false;
		},

		prevEvent: function() {
			// var selectedCalendar = this.selectedCalendar;
			var targetId = this.selectedEvent.id;

			// get the index of the selected event in the current calendar array
			var indexes = $.map(this.events, function(obj, index) {
					if(obj.id == targetId) {
							return index;
					}
			});

			var nextEventIndex = indexes[0] - 1;

			if (this.events[nextEventIndex] &&
					this.events[nextEventIndex].calendar.handle !== 'alerts') {
				this.selectedEvent = this.events[nextEventIndex];
				this.getBackgroundColor();
			} else if (this.events[nextEventIndex]) {
				this.selectedEvent = this.events[nextEventIndex];
				this.prevEvent();
			}

		},

		nextEvent: function() {
			var targetId = this.selectedEvent.id;

			var indexes = $.map(this.events, function(obj, index) {
			    if(obj.id == targetId) {
			        return index;
			    }
			});

			var nextEventIndex = indexes[0] + 1;

			if (this.events[nextEventIndex] &&
					this.events[nextEventIndex].calendar.handle !== 'alerts') {
				this.selectedEvent = this.events[nextEventIndex];
				this.getBackgroundColor();

			} else if (this.events[nextEventIndex]) {
				this.selectedEvent = this.events[nextEventIndex];
				this.nextEvent();

			}

		}
	}
});



// WEBPACK FOOTER //
// ./scripts/locations/locations-calendar-vue-app.js